/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

 const VendorAnchor = document.querySelector('.Vendor__Anchor')

 if (VendorAnchor) {

  const VendorList = document.querySelectorAll('.Vendor__List__Row')

  let clone = ''

  // clone an element in the vendorList with the letter 'É'
  // and append this element in the list with the letter 'E', and remove the old node with 'É'

  for (let i = 0; VendorList.length > i; i++) {
    if (VendorList[i].id === 'É') {
      clone = VendorList[i].firstElementChild.nextElementSibling.firstElementChild.cloneNode(true);
      VendorList[i].remove()
    }
  }

  for (let i = 0; VendorList.length > i; i++) {
    if (VendorList[i].id === 'E') {
      VendorList[i].firstElementChild.nextElementSibling.appendChild(clone)
    }
  }

 }

const DisplayFilterButton = document.querySelector('.DisplayFilter__mobile')

if (DisplayFilterButton) {
  DisplayFilterButton.addEventListener('click', function () {
    jQuery('.Drawer__Main').slideToggle('slow')
  })
}

function togglePriceFilter(filterId, min, max) {
     addRangeFilter(filterId, min + ':' + max);
}

// Submit search form on enter
if(document.querySelector('.Search__Input.ui-autocomplete-input')) {
    document.querySelector('.Search__Input.ui-autocomplete-input').addEventListener('keydown', function(e){
        if(e.keyCode === 13){
             e.currentTarget.parentNode.submit();
        }
    });
}

if (isMobileOrTablet) {
    const collectionFilterDrawer = document.querySelector('#collection-filter-drawer')
    const removeHeaderFilter = document.querySelector('.Drawer__Header.Drawer__Header--bordered.Drawer__Header--center.Drawer__Container')
    
    if (collectionFilterDrawer) {
        collectionFilterDrawer.classList.remove('Drawer')
        collectionFilterDrawer.classList.remove('Drawer--secondary')
        collectionFilterDrawer.classList.remove('Drawer--fromRight')
    }

    if (removeHeaderFilter) {
        removeHeaderFilter.style.display = 'none'
    }
}

document.addEventListener('product:added', function(event) {

  // remove pageOverlay just before it appears with the cart
  const overlay = document.querySelector('.PageOverlay')
  overlay.classList.add('is-not-visible-with-cart')

  // add a setTimeout to make we execuste our code after the code from the theme is executed
  setTimeout(() => {
    document.querySelector('#sidebar-cart').setAttribute('aria-hidden', 'false')
    // I have also removed their ugly hack on IOS to block the touch
    // I removed this function : disableBodyScroll() from the theme.min.js
    // override current theme behavior when we open the minicart, remove the no-scroll on the body
    const noScroll = document.querySelector('html')
    noScroll.classList.remove('no-scroll')
  }, 500);

  // setTimeout in order make sure the node is available
  setTimeout(() => {
    document.querySelector('[data-action=remove-item]').addEventListener('click', function() {

      document.querySelector('#sidebar-cart').setAttribute('aria-hidden', 'true')

    });
  }, 1000);

  // Hide 15 seconds after it was opened
  setTimeout(() => {
    document.querySelector('#sidebar-cart').setAttribute('aria-hidden', 'true')
  }, 15000)

  document.querySelector('.PageContainer').addEventListener('click', function () {
    document.querySelector('#sidebar-cart').setAttribute('aria-hidden', 'true')
  })

});


if(document.getElementById('js-back-to-top')) {
    const scrollToTopButton = document.getElementById('js-back-to-top');

    const scrollToTop = () => {
      const c = document.documentElement.scrollTop || document.body.scrollTop;

      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, c - c / 10);
      }
    };

    scrollToTopButton.onclick = function(e) {
      e.preventDefault();
      scrollToTop();
    }
}

if(document.querySelector('.Cart__Checkout')) {
    var buttonCart = document.querySelector('.Cart__Checkout');
    var buttonCartOverlay = document.querySelector('.cart-button-wrapper .overlay-disabled-button');
    var cartRecap = document.querySelector('.Cart__Recap');
    var checkboxCgv = document.getElementById('cgv');

    if(buttonCart.disabled) {
        buttonCartOverlay.addEventListener('click', function(e) {
            cartRecap.classList.add('with-error');
            cartRecap.classList.remove('cgv-accepted');
        });
    }

    if (checkboxCgv) {
      checkboxCgv.addEventListener( 'change', function() {
          if(this.checked) {
              cartRecap.classList.remove('with-error');
              cartRecap.classList.add('cgv-accepted');
          } else {
              cartRecap.classList.add('with-error');
              cartRecap.classList.remove('cgv-accepted');
          }
      });
    }
}

function Search() {
    const $openBtn = document.querySelectorAll('.js-open-search')
    const $closeBtn = document.querySelectorAll('.js-close-search')
    const $nav = document.querySelector('.Header__MainNav')

    if (!$openBtn.length || !$closeBtn.length) return false

    $openBtn.forEach( function(el) {
        el.addEventListener('click', function() {
            $nav.classList.add('u-pointer-none')
        })
    })
    $closeBtn.forEach( function(el) {
        el.addEventListener('click', function() {
            $nav.classList.remove('u-pointer-none')
        })
    })
}

(function(){

    gF(document).on('click','.CollectionToolbar__Item--filter', function(){
        // gF("#collection-filter-drawer").find(".Drawer__Main").empty();
        // gF("#collection-filter-drawer").find(".Drawer__Footer").remove();
        if(gF("#gf-tree").length == 0){
            globofilter.initFilter();
        }
        // gF("#gf-tree").appendTo("#collection-filter-drawer .Drawer__Main");
    });

    // gF(document).on('click','.gf-clear, .gf-refine-toggle, [onclick^="toggleCheckboxFilter"], [onclick^="togglePriceFilter"]', function(){
    //     gF("#collection-filter-drawer").find(".Drawer__Close").trigger('click');
    // });

    var password = document.querySelector('.Form__Input--password');
    var submit = document.querySelector('.Form__Submit');

    var helperText = {
        charLength: document.querySelector('.helper-text .length'),
        lowercase: document.querySelector('.helper-text .lowercase'),
        uppercase: document.querySelector('.helper-text .uppercase'),
        special: document.querySelector('.helper-text .special'),
        number: document.querySelector('.helper-text .number')
    };

    var pattern = {
        charLength: function() {
            if( password.value.length >= 8 ) {
                return true;
            }
        },
        lowercase: function() {
            var regex = /^(?=.*[a-z]).+$/; // Lowercase character pattern

            if( regex.test(password.value) ) {
                return true;
            }
        },
        uppercase: function() {
            var regex = /^(?=.*[A-Z]).+$/; // Uppercase character pattern

            if( regex.test(password.value) ) {
                return true;
            }
        },
        special: function() {
            var regex = /^(?=.*[/\W|_/g]).+$/; // Special character or number pattern

            if( regex.test(password.value) ) {
                return true;
            }
        },
        number: function() {
            var regex = /^(?=.*[0-9]).+$/; // Special character or number pattern

            if( regex.test(password.value) ) {
                return true;
            }
        }
    };

    if(password){
        // override submit value because when the newsletter popup is active submit equal the newsletters submit instead
        submit = document.querySelector('.Form__Submit.Form__Submit--with-password');

        // Listen for keyup action on password field
        password.addEventListener('keyup', function (){
            // Check that password is a minimum of 8 characters
            patternTest( pattern.charLength(), helperText.charLength );

            // Check that password contains a lowercase letter
            patternTest( pattern.lowercase(), helperText.lowercase );

            // Check that password contains an uppercase letter
            patternTest( pattern.uppercase(), helperText.uppercase );

            // Check that password contains a special character
            patternTest( pattern.special(), helperText.special );

            // Check that password contains a number
            patternTest( pattern.number(), helperText.number );

            // Check that all requirements are fulfilled
            if( hasClass(helperText.charLength, 'valid') &&
                hasClass(helperText.lowercase, 'valid') &&
                hasClass(helperText.uppercase, 'valid') &&
                hasClass(helperText.special, 'valid') &&
                hasClass(helperText.number, 'valid')
            ) {
                addClass(password.parentElement, 'valid');
                submit.disabled = false;
            }
            else {
                removeClass(password.parentElement, 'valid');
                submit.disabled = true;
            }
        });
    }

    function patternTest(pattern, response) {
        if(pattern) {
            addClass(response, 'valid');
        }
        else {
            removeClass(response, 'valid');
        }
    }

    function addClass(el, className) {
        if (el.classList) {
            el.classList.add(className);
        }
        else {
            el.className += ' ' + className;
        }
    }

    function removeClass(el, className) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    function hasClass(el, className) {
        if (el.classList) {
            return el.classList.contains(className);
        }
        else {
            new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
        }
    }

    /// Exe function
    Search()

})();